import React from 'react';
import TeamSubteamMembersEditContainer from './editMembers/TeamSubteamMembersEditContainer';
import TeamSubteamMembersGeneralContainer from './general/TeamSubteamMembersGeneralContainer';
import TeamSubteamMembersRestrictionsContainer from './restrictions/TeamSubteamMembersRestrictionsContainer';
import TeamSubteamMembersTemplateContainer from './template/TeamSubteamMembersTemplateContainer';
import TeamIntegrationsContainer from 'team/pages/TeamIntegrationsContainer';
import TeamSubteamMembersViewContainer from './view/TeamSubteamMembersViewContainer';

const TeamSubteamMembersContent = ({ selectedItem, subteamId }) => {
    switch (selectedItem) {
        case 'editMembers':
            return <TeamSubteamMembersEditContainer subteamId={subteamId} />;
        case 'general':
            return <TeamSubteamMembersGeneralContainer subteamId={subteamId} />;
        case 'restrictions':
            return <TeamSubteamMembersRestrictionsContainer subteamId={subteamId} />;
        case 'templateAutoAssign':
            return <TeamSubteamMembersTemplateContainer subteamId={subteamId} />;
        case 'integrations':
            return <TeamIntegrationsContainer subteamId={subteamId} />;
        case 'viewMembers':
            return <TeamSubteamMembersViewContainer subteamId={subteamId} />;
        default:
            return <TeamSubteamMembersEditContainer subteamId={subteamId} />;
    }
};

export default TeamSubteamMembersContent;

